import { hotSeries } from "@/mocks/comics";

export default function HotSeries() {
  return (
    <section id="hot" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 text-accent-700 text-sm font-medium">
              <i className="ri-fire-line" />
              HOT RANKING
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">热门连载追踪</h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">全网都在追的高人气连载，热门热更一网打尽</p>
          </div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm font-medium px-4 py-2 whitespace-nowrap">
            <i className="ri-arrow-up-line" />
            实时热榜
          </span>
        </div>

        <div className="space-y-3 md:space-y-4">
          {hotSeries.map((comic, index) => (
            <article
              key={comic.id}
              className="group flex items-center gap-4 md:gap-6 rounded-xl bg-background-50 border border-background-200 p-3 md:p-4 transition-all duration-300 hover:border-accent-300"
            >
              {/* rank */}
              <div
                className={`flex items-center justify-center w-8 h-10 md:w-10 md:h-12 rounded-lg font-heading text-lg md:text-2xl shrink-0 ${
                  index < 3 ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-600"
                }`}
              >
                {index + 1}
              </div>

              {/* cover */}
              <a href="#hot" className="shrink-0 cursor-pointer">
                <img
                  src={comic.cover}
                  alt={`${comic.title}封面`}
                  className="w-14 h-[76px] md:w-16 md:h-[88px] rounded-lg object-cover object-top"
                />
              </a>

              {/* info */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-medium text-foreground-950 text-sm md:text-base truncate">{comic.title}</h3>
                  <span className="rounded-md bg-secondary-100 text-secondary-900 text-xs px-2 py-0.5 whitespace-nowrap">
                    {comic.genre}
                  </span>
                </div>
                <p className="mt-1 text-xs md:text-sm text-foreground-600 truncate">{comic.latestChapter}</p>
                <div className="mt-2 flex items-center gap-2 md:gap-3 flex-wrap">
                  <div className="hidden sm:flex flex-1 max-w-[280px] h-1.5 rounded-full bg-background-200 overflow-hidden">
                    <div
                      className="h-full rounded-full bg-primary-500"
                      style={{ width: `${Math.min(100, 30 + index * 12)}%` }}
                    />
                  </div>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{comic.updateTime}</span>
                  <div className="flex items-center gap-1.5">
                    {comic.tags.map((tag) => (
                      <span key={tag} className="rounded-full bg-primary-50 text-primary-700 text-xs px-2.5 py-0.5 whitespace-nowrap">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              <a
                href="#hot"
                className="hidden sm:inline-flex items-center whitespace-nowrap rounded-full border border-background-300 text-foreground-700 hover:text-primary-600 hover:border-primary-300 text-xs md:text-sm font-medium px-4 py-2 transition-colors cursor-pointer"
              >
                追更
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}